//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { CampaignsStateFactory } from '@campaigns/routes/stateFactory';

import {
  componentNameToTemplate,
  hasAllFeatures,
  hasFeature,
} from 'app/initialization/routing/stateHelpers';

export const contentSourceStates = {
  'campaigns.content-source': CampaignsStateFactory({
    url: '/reviewsource',
    data: {
      hasAccess: () => hasFeature(FeatureNames.ContentSource),
      title: 'Campaigns: ReviewSource',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsContentSourceOverviewPage'),
      },
    },
  }),

  'campaigns.content-source-available-reviews': CampaignsStateFactory({
    url: '/reviewsource/available-reviews?:productId&:viewCart&:sortBy&:searchText&:currentPage&:itemsPerPage',
    data: {
      hasAccess: () => hasFeature(FeatureNames.ContentSource),
      title: 'Campaigns: ReviewSource Available Reviews',
    },
    template: componentNameToTemplate(
      'campaignsContentSourceAvailableReviewsPage',
    ),
  }),

  'campaigns.content-source-cart-checkout': CampaignsStateFactory({
    url: '/reviewsource/cart-checkout?:productId&sortBy&:searchText&:currentPage&:itemsPerPage',
    data: {
      hasAccess: () => hasFeature(FeatureNames.ContentSource),
      title: 'Campaigns: ReviewSource Cart Checkout',
    },
    template: componentNameToTemplate('campaignsContentSourceCartCheckoutPage'),
  }),

  'campaigns.content-source-orders': CampaignsStateFactory({
    url: '/reviewsource/orders?:sortBy&:searchText&:currentPage&:itemsPerPage',
    data: {
      hasAccess: () =>
        hasAllFeatures(
          FeatureNames.ContentSource,
          FeatureNames.ContentSourceOrders, // TODO: PD-293027 - Remove feature flag check once ContentSourceOrders is released
        ),
      title: 'Campaigns: ReviewSource Orders',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsContentSourceOrdersPage'),
      },
    },
  }),

  'campaigns.content-source-orders-media': CampaignsStateFactory({
    url: '/reviewsource/orders/media',
    data: {
      hasAccess: () =>
        hasAllFeatures(
          FeatureNames.ContentSource,
          FeatureNames.ContentSourceOrders, // TODO: PD-293027 - Remove feature flag check once ContentSourceOrders is released
        ),
      title: 'Campaigns: ReviewSource  Media',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsContentSourceMediaPage'),
      },
    },
  }),

  'campaigns.content-source-orders-reviews': CampaignsStateFactory({
    url: '/reviewsource/orders/reviews',
    data: {
      hasAccess: () =>
        hasAllFeatures(
          FeatureNames.ContentSource,
          FeatureNames.ContentSourceOrders, // TODO: PD-293027 - Remove feature flag check once ContentSourceOrders is released
        ),
      title: 'Campaigns: ReviewSource Orders Reviews',
    },
    views: {
      main: {
        template: componentNameToTemplate('campaignsContentSourceReviewsPage'),
      },
    },
  }),

  'campaigns.content-source-order-details': CampaignsStateFactory({
    url: '/reviewsource/orders/:orderId',
    data: {
      hasAccess: () =>
        hasAllFeatures(
          FeatureNames.ContentSource,
          FeatureNames.ContentSourceOrders, // TODO: PD-293027 - Remove feature flag check once ContentSourceOrders is released
        ),
      title: 'Campaigns: ReviewSource Order Details',
    },
    views: {
      main: {
        template: componentNameToTemplate(
          'campaignsContentSourceOrderDetailsPage',
        ),
      },
    },
  }),
};
